import { c as _c } from "react/compiler-runtime";
import { IconButton, Tooltip } from 'platform/components';
import { ThemeIconKey } from 'platform/foundation';
import { memo } from 'react';
import { useActionLocksForRow } from '../../../../../../store/selectors/useActionLocks';
import { ActionDefinitionObject } from '../../../../../../types/ActionDefinition';
import { RowData } from '../../../../../../types/RowData';
import { getActionButtonSize } from '../../../../../../utils/getActionButtonSize';
import { getRowPaddingClass, LineHeight } from '../../../../../../utils/lineHeightToValue';
import { partitionRowActions } from '../../../../../../utils/partitionRowActions';
import { ActionColumnCell } from './components/ActionColumnCell/ActionColumnCell';
import { RowActionsOverflow } from './components/RowActionsOverflow/RowActionsOverflow';
export type RowActionsProps = {
  row: RowData;
  actionsDefinition: ActionDefinitionObject;
  onActionClick: (actionKey: string, row: RowData, event: React.MouseEvent) => void;
  isMobile: boolean;
  rowHeight: LineHeight;
  actionColumnWidth: number;
  heightPx: number;
  isSelected?: boolean;
  isStriped?: boolean;
  isDisabled?: boolean;
};

// memo: rendered N times (one per visible row); only re-renders when own row's actions change.
export const RowActions = memo(props => {
  const $ = _c(10);
  const {
    iconActions,
    overflowActions
  } = partitionRowActions(props.row.actions, props.actionsDefinition);
  let t0;
  if ($[0] !== props.isMobile || $[1] !== props.rowHeight) {
    t0 = getActionButtonSize(props.rowHeight, props.isMobile);
    $[0] = props.isMobile;
    $[1] = props.rowHeight;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const buttonSize = t0;
  const paddingClass = getRowPaddingClass[props.rowHeight];
  const lockedActionKeys = useActionLocksForRow(props.row.id);
  let t1;
  if ($[3] !== props) {
    t1 = (actionKey, nativeEvent) => {
      props.onActionClick(actionKey, props.row, {
        stopPropagation: _temp,
        nativeEvent
      } as React.MouseEvent);
    };
    $[3] = props;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleOverflowActionClick = t1;
  const hasActions = iconActions.length > 0 || overflowActions.length > 0;
  const T0 = ActionColumnCell;
  const t2 = hasActions && <div className={`flex items-center h-full gap-1 ${paddingClass}`}>{iconActions.map(action => {
      const iconValue = action.definition.icon.value as ThemeIconKey;
      const isThisActionDisabled = props.isDisabled === true || lockedActionKeys.has(action.actionKey);
      return <Tooltip key={action.actionKey} label={action.definition.title} description={action.definition.description} placement="left" hasAutoWidth={true}><IconButton size={buttonSize} icon={iconValue} aria-label={action.definition.title ?? "row action"} onClick={event => props.onActionClick(action.actionKey, props.row, event)} isDisabled={isThisActionDisabled} data-testid={`button-rowAction.${action.actionKey}`} /></Tooltip>;
    })}<RowActionsOverflow overflowActions={overflowActions} onActionClick={handleOverflowActionClick} rowId={props.row.id} buttonSize={buttonSize} isDisabled={props.isDisabled === true} lockedActionKeys={lockedActionKeys} /></div>;
  let t3;
  if ($[5] !== T0 || $[6] !== props.actionColumnWidth || $[7] !== props.heightPx || $[8] !== t2) {
    t3 = <T0 width={props.actionColumnWidth} heightPx={props.heightPx}>{t2}</T0>;
    $[5] = T0;
    $[6] = props.actionColumnWidth;
    $[7] = props.heightPx;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
});
function _temp() {}